var nurseslounge_myDashboard_camera = {
    init:function($params){
        nurseslounge_myDashboard_camera.profile_image();
    },
    profile_image:function(){
        var $homeTakepictureModal = $("#nurseslounge-home-takepicture-modal");
        $("#content .image-change").unbind().click(function(){
            $homeTakepictureModal.find(".camera").unbind().click(function(){
                $homeTakepictureModal.find(".camera-container").fadeOut();
                $homeTakepictureModal.find(".storage-container").fadeOut();
                $homeTakepictureModal.find(".restore-container").fadeOut();
                nurseslounge_myDashboard_camera.profile_image_animation(function(){
                    nurseslounge_myDashboard_camera.profile_image_camera();
                });
            });
            $homeTakepictureModal.find(".storage-file").unbind().change(function(){
                nurseslounge_myDashboard_camera.profile_image_file(this);
            });
            $homeTakepictureModal.find(".storage").unbind().click(function(){
                $homeTakepictureModal.find(".camera-container").fadeOut();
                $homeTakepictureModal.find(".storage-container").fadeOut();
                $homeTakepictureModal.find(".restore-container").fadeOut();
                nurseslounge_myDashboard_camera.profile_image_animation(function(){
                    $homeTakepictureModal.find(".image-button").fadeIn();
                    $homeTakepictureModal.find(".save-image-picture").removeClass('active');
                    $homeTakepictureModal.find(".storage-file").click();
                    $homeTakepictureModal.find(".take-image-picture").unbind().click(function(){
                        $homeTakepictureModal.find(".storage-file").click();
                    });
                });
            });
            $homeTakepictureModal.find(".restore").unbind().click(function(){
                $homeTakepictureModal.find(".camera-container").fadeOut();
                $homeTakepictureModal.find(".storage-container").fadeOut();
                $homeTakepictureModal.find(".restore-container").fadeOut();
                nurseslounge_myDashboard_camera.profile_image_camera_restore_picture();
            });
            $homeTakepictureModal.unbind().on('hidden.bs.modal', function () {
                $homeTakepictureModal.find(".storage-file").val('');
                $homeTakepictureModal.find(".camera-container").show();
                $homeTakepictureModal.find(".storage-container").show();
                $homeTakepictureModal.find(".restore-container").show();
                $homeTakepictureModal.find(".modal-body").css('height', 'auto');
                $homeTakepictureModal.find(".camera-button").hide();
                $homeTakepictureModal.find(".my-camera").html('');
                $homeTakepictureModal.find(".image-button").hide();
                Webcam.reset();
            }).modal('show');
        });
    },
    profile_image_animation:function(cback){
        var $homeTakepictureModal = $("#nurseslounge-home-takepicture-modal");
        $homeTakepictureModal.find(".modal-body").animate({
            "height": "400px"
        }, 500, "linear", function() {
            cback();
        });
    },
    profile_image_file:function($that){
        var $homeTakepictureModal = $("#nurseslounge-home-takepicture-modal");
        $homeTakepictureModal.find(".my-camera").html('<img src="data:," id="profile-previous-image">').promise().done(function(){
            libs.renderImage($that, '#nurseslounge-home-takepicture-modal .my-camera #profile-previous-image');
            var $myCamera = $("#nurseslounge-home-takepicture-modal .my-camera");
            var $image = $("#profile-previous-image").cropme({
                "container": {
                    "width": $myCamera.width(),
                    "height": $myCamera.height()
                },
                "viewport": {
                    "width": ($myCamera.width() - 140),
                    "height": ($myCamera.width() - 140),
                    "type": "circle",
                    "border": {
                        "width": 5,
                        "enable": true,
                        "color": "#ffffff"
                    }
                },
                "zoom": {
                    "enable": true,
                    "mouseWheel": true,
                    "slider": true
                },
                "rotation": {
                    "slider": false,
                    "enable": false,
                    "position": "left"
                },
                "transformOrigin": "viewport"
            });
            if($($that)[0].files != ''){
                $homeTakepictureModal.find(".save-image-picture").unbind().click(function(){
                    $image.cropme('crop', {
                        type: 'base64'
                    }).then(function($imageBase64) {
                        nurseslounge_myDashboard_camera.profile_image_camera_save_picture($imageBase64);
                    });
                }).addClass('active');
            }else{
                $homeTakepictureModal.find(".save-image-picture").unbind();
            }
        });
    },
    profile_image_camera:function(){
        var $homeTakepictureModal = $("#nurseslounge-home-takepicture-modal");
        $homeTakepictureModal.find(".my-camera").html('').promise().done(function(){
            Webcam.reset();
            Webcam.attach($homeTakepictureModal.find(".my-camera")[0]);
            $homeTakepictureModal.find(".camera-button").fadeIn();
            $homeTakepictureModal.find(".save-camera-picture").unbind().removeClass('active');
            $homeTakepictureModal.find(".take-camera-picture").html('Take Picture').unbind().click(function(){
                nurseslounge_myDashboard_camera.profile_image_camera_take_picture();
            });
        });
    },
    profile_image_camera_take_picture:function(){
        var $homeTakepictureModal = $("#nurseslounge-home-takepicture-modal");
        Webcam.snap( function($imageBase64) {
            $homeTakepictureModal.find(".my-camera").html('<img src="'+$imageBase64+'" id="profile-previous-image">').promise().done(function(){
                var $myCamera = $("#nurseslounge-home-takepicture-modal .my-camera");
                var $image = $("#profile-previous-image").cropme({
                    "container": {
                        "width": $myCamera.width(),
                        "height": $myCamera.height()
                    },
                    "viewport": {
                        "width": ($myCamera.width() - 140),
                        "height": ($myCamera.width() - 140),
                        "type": "circle",
                        "border": {
                            "width": 5,
                            "enable": true,
                            "color": "#ffffff"
                        }
                    },
                    "zoom": {
                        "enable": true,
                        "mouseWheel": true,
                        "slider": true
                    },
                    "rotation": {
                        "slider": false,
                        "enable": false,
                        "position": "left"
                    },
                    "transformOrigin": "viewport"
                });
                $homeTakepictureModal.find(".take-camera-picture").html('Reset').unbind().click(function(){
                    nurseslounge_myDashboard_camera.profile_image_camera();
                });
                $homeTakepictureModal.find(".save-camera-picture").unbind().click(function(){
                    $image.cropme('crop', {
                        type: 'base64'
                    }).then(function($imageBase64) {
                        nurseslounge_myDashboard_camera.profile_image_camera_save_picture($imageBase64);
                    });
                }).addClass('active');
            });
        });
    },
    profile_image_camera_save_picture:function($imageBase64){
        var $image = libs.b64toBlob($imageBase64);
        var $formData = new FormData();
        $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
        $formData.append('image', $image);
        $formData.append('user_id', libs.memoryGet('user_id'));
        $.ajax({
            type: 'POST',
            url: '/myDashboard/header/updateImage',
            data: $formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function ($data) {
                libs.expire($data);
                if ($data.status == 'success') {
                    libs.refreshBoxFrom('.profile-image-box', null, function(){
                        nurseslounge_myDashboard_camera.profile_image();
                        if(window.location.pathname == '/myDashboard/myProfile') {
                            nurseslounge_myDashboard_myProfile.task_list_container(function($container){
                                nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                            });
                        }
                    });
                    $("#nurseslounge-home-takepicture-modal").modal('hide');
                }
            }
        });
    },
    profile_image_camera_restore_picture:function(){
        $.ajax({
            url: "/myDashboard/header/restoreImage",
            method: "POST",
            cache:false,
            dataType: "json",
            data:{user_id:libs.memoryGet('user_id')},
            success: function ($data) {
                libs.expire($data);
                if ($data.status == 'success') {
                    libs.refreshBoxFrom('.profile-image-box', null, function(){
                        nurseslounge_myDashboard_camera.profile_image();
                        if(window.location.pathname == '/myDashboard/myProfile') {
                            nurseslounge_myDashboard_myProfile.task_list_container(function($container){
                                nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                            });
                        }
                    });
                    $("#nurseslounge-home-takepicture-modal").modal('hide');
                }
            }
        });
    }
};
